import { Table, Text } from 'evergreen-ui';
import ConsumableRow from './ConsumableRow';

const ConsumablesTable = ({ consumables, isEditing, onQuantityChange, onRemove }) => {
  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell flexBasis={60} flexShrink={0} flexGrow={0}>Image</Table.HeaderCell>
        <Table.HeaderCell flexBasis={100} flexShrink={0} flexGrow={0}>Type</Table.HeaderCell>
        <Table.HeaderCell>Name</Table.HeaderCell>
        <Table.HeaderCell flexBasis={100} flexShrink={0} flexGrow={0}>Quantity</Table.HeaderCell>
        <Table.HeaderCell flexBasis={60} flexShrink={0} flexGrow={0}>Actions</Table.HeaderCell>
      </Table.Head>
      <Table.Body>
        {consumables.length === 0 && (
          <Table.Row>
            <Table.Cell>
              <Text color="muted">No consumables added yet</Text>
            </Table.Cell>
          </Table.Row>
        )}
        {consumables.map((c, index) => (
          <ConsumableRow
            key={`consumable-${c.id || index}`}
            consumable={c}
            index={index}
            isEditing={isEditing}
            onQuantityChange={onQuantityChange}
            onRemove={onRemove}
          />
        ))}
      </Table.Body>
    </Table>
  );
};

export default ConsumablesTable;
